import { NgModule } from '@angular/core'
import { ConfigModule } from '@spartacus/core'
import { IconConfig, IconResourceType, ICON_TYPE } from '@spartacus/storefront'
import { environment } from '../../../environments/environment'

@NgModule({
  imports: [
    ConfigModule.withConfig({
      icon: {
        symbols: {
          SEARCH: 'search',
          CART: 'shopping_cart',
          RESET: 'cancel',
          CARET_DOWN: 'keyboard_arrow_down',
        },
        resources: [
          {
            type: IconResourceType.LINK,
            url: 'https://use.fontawesome.com/releases/v5.8.1/css/all.css',
          },
          {
            type: IconResourceType.SVG,
            url: environment.deployPath + '/assets/icons/sprite.svg',
            types: [
              ICON_TYPE.CART,
              ICON_TYPE.RESET,
              ICON_TYPE.SEARCH,
              ICON_TYPE.CARET_DOWN,
            ],
          },
        ],
      },
    } as IconConfig),
  ],
})
export class VsIconModule {}
